import service from "./service";

const defaults = {
  clock: {
    last_recvd_remote_time: null,
    last_remote_to_local_time: null
  },
  versionsDialog: {
    dialog: false,
    versions: {
      official: null,
      internal: {
        auth: null,
        ca: null,
        config: null,
        monitoring: null
      }
    }
  }
};

const module = {
  namespaced: true,
  state: { ...defaults },
  mutations: {
    loadClock(state, data) {
      state.clock.last_recvd_remote_time = new Date(data).getTime();
      state.clock.last_remote_to_local_time = new Date().getTime();
    },
    fillVersions(state, data) {
      state.versionsDialog.versions = {
        official: data.versions.official,
        internal: {
          auth: data.versions.internal.auth,
          ca: data.versions.internal.ca,
          config: data.versions.internal.config,
          monitoring: data.versions.internal.monitoring
        }
      };
    },
    toggleVersionsDialog(state, data) {
      state.versionsDialog.dialog = data;
    }
  },
  actions: {
    fetchServerClock({ commit }) {
      return service.fetchServerTime().then(response => {
        let data = response.data.server_clock;
        commit("loadClock", data);
      });
    },
    fetchVersions({ commit }) {
      return service.fetchVersions().then(response => {
        let data = response.data;
        commit("fillVersions", data);
      });
    }
  }
};

export default module;
